import Vue from 'vue'
import axios from 'axios'
import VueLocalStorage from 'vue-localstorage'

Vue.use(VueLocalStorage);

const state = {
    step: [],
    stepSequences: []
};

const getters = {
    step(state) {
        return state.step;
    },
    stepSequences(state){
        return state.stepSequences
    }
};

const mutations = {
    SET_STEP(state, newStep) {
        state.step = newStep;
    },
    SET_STEP_SEQUENCES(state, newStepSequences)
    {
        state.stepSequences = newStepSequences;
    }
};

const actions = {
    loadStepWithQuestionnaireQuestionsAnswers(context, stepId) {
        return new Promise((resolve, reject) => {
            axios.get("/api/category-steps/get-with-questionnaire-questions-answers/" + stepId)
                .then(response => {
                    context.commit("SET_STEP", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    loadCategoryStepSequencesForGivenSteps(context, stepIds) {
        return new Promise((resolve, reject) => {
            axios.post('/api/category-steps/sequences/get-for-steps/', stepIds)
                .then(response => {
                    context.commit("SET_STEP_SEQUENCES", response.data);
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
    
};

export default {
    state,
    getters,
    mutations,
    actions
};